import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0032',
    ecrans: ['00-2'],
    params: ['id', '?ebvcleint']
});
